import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "London 7",
  "description": "",
  "published": "2007-09-29T00:00:00.000Z",
  "redirect_from": ["/blog/london-7/swizec/149"],
  "categories": "travel",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Tomorrow I am leaving London and going home. It will be a sad moment as I have come to quite like London and all its little quirks and strangenesses. To be perfectly honest it feels more home than home does and I must come live here some day because I quite simply love everything.`}</p>
    <p>{`The thing I love most, or let's say one of the things I love most, is the efficiency of public transport. At home streets are filled with cars and sidewalks are full of parked cars, most streets are also lined with them. Around here it's very rare to spot a regular car, which is probably also due to my not leaving the centre of London. However, there are next to no parking spaces anywhere and still the pavement is nicely walkable.`}</p>
    <p>{`From my observatoin the only people who use their own cars around here are the very rich because you can see quite some expensive cars around, but hey, why would somebody own a Porsche if they don't intend on showing it off a bit? The reason why people can do this is because public transport actually works and is quick and painless.`}</p>
    <p>{`The underground is simply marvelous and feels almost like teleportation. You pop out of street level and very soon you pop up somewhere else. It can get a bit crowded and annoying at times, especially around the peaks, but otherwise it's very nice. Haven't tried riding a bus, but there doesn't seem to be a lack of those either. And of course the oyster card is simply a magnificent system.`}</p>
    <p>{`If only public transport at home would be this useful and I believe much of our trouble would go away.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      